<ng-container *transloco="let t; read: 'action-plan-details-tasks-tab'">
  <div class="action-plan-details-tasks-tab__container">
    <div class="action-plan-details-tasks-tab__header">
      <span class="action-plan-details-tasks-tab__title">{{
        t('title', {
          breakdown: actionPlan.metadata.breakdown,
          metric: actionPlan.metric_name,
        })
      }}</span>

      <div class="action-plan-details-tasks-tab__header-actions">
        <div
          [matBadge]="hasActiveFilter ? '1' : ''"
          class="action-plan-details-tasks-tab__filter-icon-wrapper"
        >
          <xi-icon-button icon="filter" color="CX" (onClick)="onOpenFilterModal()">
          </xi-icon-button>
        </div>

        <xi-icon-button icon="kabob" color="CX" [disabled]="true"> </xi-icon-button>
      </div>
    </div>

    <div class="action-plan-details-tasks-tab__actions">
      <xi-search-box
        [placeholder]="t('searchbox')"
        [value]="searchValue"
        (keyup)="onSearch($event.target.value)"
        (onCancelClick)="onSearch('')"
        class="action-plan-details-tasks-tab__search-box"
      ></xi-search-box>
    </div>

    <table
      mat-table
      [dataSource]="dataSource"
      multiTemplateDataRows
      matSort
      [matSortActive]="sort.active"
      [matSortDirection]="sort.direction"
      matSortDisableClear
      (matSortChange)="onSortChange($event)"
      class="action-plan-details-tasks-tab__table"
    >
      <ng-container matColumnDef="icon">
        <th mat-header-cell *matHeaderCellDef>
          <mat-icon
            class="action-plan-details-tasks-tab__expand-icon pointer"
            (click)="onToggleAllRow()"
            [ngClass]="
              isAllRowExpanded
                ? 'action-plan-details-tasks-tab__expand-icon--open'
                : 'action-plan-details-tasks-tab__expand-icon--closed'
            "
            >expand_more</mat-icon
          >
        </th>
        <td mat-cell *matCellDef="let task">
          <mat-icon
            class="action-plan-details-tasks-tab__expand-icon pointer"
            (click)="onToggleRow(task)"
            [ngClass]="
              task.isExpanded
                ? 'action-plan-details-tasks-tab__expand-icon--open'
                : 'action-plan-details-tasks-tab__expand-icon--closed'
            "
            >expand_more</mat-icon
          >
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ t('name') }}
        </th>
        <td
          mat-cell
          *matCellDef="let task"
          class="action-plan-details-tasks-tab__bold-cell action-plan-details-tasks-tab__truncate-cell"
          [matTooltip]="task.name"
          appShowMatTooltipIfTruncated
        >
          {{ task.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="item_name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ t('related-action-item') }}
        </th>
        <td
          mat-cell
          *matCellDef="let task"
          class="action-plan-details-tasks-tab__bold-cell action-plan-details-tasks-tab__truncate-cell"
          [matTooltip]="task.itemName"
          appShowMatTooltipIfTruncated
        >
          <a
            class="action-plan-details-tasks-tab__action-item-link"
            (click)="onNavigateToItem(task.itemId)"
            >{{ task.itemName }}</a
          >
        </td>
      </ng-container>

      <ng-container matColumnDef="due_date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ t('due-date') }}
        </th>
        <td
          mat-cell
          *matCellDef="let task"
          [ngClass]="task.isExpired ? 'action-plan-expired' : ''"
          [matTooltip]="task.expiredTooltip"
        >
          {{ task.dueDate | date: 'dd-MM-yyyy' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ t('status') }}
        </th>
        <td mat-cell *matCellDef="let task">
          <app-status-label
            [status]="task.status"
            [isFixed]="isReadOnly"
            (statusChange)="onStatusChange($event, task)"
          ></app-status-label>
        </td>
      </ng-container>

      <ng-container matColumnDef="assignee">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ t('assignee') }}
        </th>
        <td
          mat-cell
          *matCellDef="let task"
          class="action-plan-details-tasks-tab__truncate-cell"
          [matTooltip]="task.assignee"
          appShowMatTooltipIfTruncated
        >
          {{ task.assignee }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let task">
          <div
            [matMenuTriggerFor]="!isReadOnly ? actionsMenu : null"
            (menuOpened)="onOpenActionsMenu(task)"
          >
            <xi-icon-button
              color="CX"
              buttonSize="small"
              icon="kabob"
              [disabled]="isReadOnly"
            ></xi-icon-button>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="detail">
        <td mat-cell *matCellDef="let task" [attr.colspan]="displayedColumns.length">
          <div class="action-plan-details-tasks-tab__detail-container">
            <div class="action-plan-details-tasks-tab__detail-notes-container">
              <span
                [ngClass]="!task.notes ? 'italic' : ''"
                class="action-plan-details-tasks-tab__detail-notes"
                >{{ task.notes || t('no-notes') }}</span
              >

              <!-- just for fill other columns empty space -->
              <div></div>
            </div>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="action-plan-details-tasks-tab__main-row"
        [ngClass]="
          row.isExpanded
            ? 'action-plan-details-tasks-tab__main-row--expanded'
            : 'action-plan-details-tasks-tab__main-row--collapsed'
        "
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: ['detail']"
        class="action-plan-details-tasks-tab__detail-row"
        [ngClass]="
          row.isExpanded
            ? 'action-plan-details-tasks-tab__detail-row--expanded'
            : 'action-plan-details-tasks-tab__detail-row--collapsed'
        "
      ></tr>
    </table>
  </div>

  <mat-menu #actionsMenu>
    <ng-template matMenuContent>
      <button mat-menu-item (click)="onEditTask()">
        {{ t('edit-task') }}
      </button>
      <button mat-menu-item (click)="onDeleteTask()">
        {{ t('delete-task') }}
      </button>
    </ng-template>
  </mat-menu>
</ng-container>

@if (isFilterModalOpen) {
  <app-lex-xi-modal
    [isVisible]="isFilterModalOpen"
    (close)="onCloseFilterModal(null)"
    maxWidth="400px"
  >
    <ng-template appXIModalContent>
      @if (isFilterModalOpen) {
        <app-action-item-list-filter
          [filter]="filter"
          [isActionItem]="false"
          (modalClose)="onCloseFilterModal($event)"
        ></app-action-item-list-filter>
      }
    </ng-template>
  </app-lex-xi-modal>
}

<app-lex-xi-modal
  [isVisible]="isActionTaskDialogOpen"
  (close)="onCloseActionTaskDialog()"
  maxWidth="800px"
>
  <ng-template appXIModalContent>
    @if (isActionTaskDialogOpen) {
      <app-create-action-task-dialog
        [actionPlan]="actionPlan"
        [actionItem]="actionItemToDialog"
        [actionTask]="actionTaskToDialog"
        [fromDashboard]="false"
        (update)="onUpdateActionTask($event)"
        (modalClosed)="onCloseActionTaskDialog()"
      ></app-create-action-task-dialog>
    }
  </ng-template>
</app-lex-xi-modal>
